<template>
  <div id="create-profile-container" class="container-24">
    <loading
      :show="showSpinner"
      label="Loading..."
      overlay="true">
    </loading>

    <div class="container profile-container">
      <div class="row profile-section">
        <section class="col-sm-12 profile-desc-header">
          <h3 class="title-24">2. Create Your Login</h3>
          <section class="card-24">
          </section>
        </section>
      </div>
    </div>

    <div class="container profile-container">
      <h3 class="title-24"><i class="fa fa-user"></i> Verify your information</h3>
      <user-information-form :userInformation="memberData" @input="nValue => setMemberData(nValue)"></user-information-form>
    </div>

    <div class="container profile-container">
      <h3 class="title-24"><i class="fa fa-address-card-o"></i> Create your login credentials</h3>
      <login-credentials-form :value="userCredentials"
                              @input="nValue => setUserCredentials(nValue)" >
      </login-credentials-form>
    </div>

    <div class="container profile-container">
      <h3 class="title-24"><i class="fa fa-question-circle-o"></i> Set up your security question</h3>
      <security-question-form :securityQuestionCatalog="securityQuestionCatalog"
                              :value="selectedSecurityQuestion"
                              @input="nValue => setSelectedQuestion(nValue)">
      </security-question-form>
    </div>

    <div class="container profile-container" id="terms-of-use">
      <terms-of-use :value="termsOfUse"
                    v-on:submitForm="submitForm()"
                    v-on:cancelRegistration="cancelRegistration()"
                    :areAllFormsValid="areAllFormsValid"
                    :reEnableSubmitButton="reEnableSubmitButton"
                    @input="nValue => setTermsOfUseData(nValue)">
      </terms-of-use>
    </div>

    <already-registered-modal v-if="isModalOpen" v-on:closeModal="closeModal"></already-registered-modal>

  </div>
</template>

<script>
  import loading from '@/components/Loading.vue'
  import { createProfileService } from '../services/ServiceContainer'

  import UserInformationForm from '@/components/UserInformationForm'
  import LoginCredentialsForm from '@/components/LoginCredentialsForm'
  import SecurityQuestionForm from '@/components/SecurityQuestionForm'
  import TermsOfUse from '@/components/TermsOfUse'
  import AlreadyRegisteredModal from '@/components/AlreadyRegisteredModal'
  import { StringUtils } from 'my-account-common'

  import { mapGetters } from 'vuex'

  export default {
    name: 'create-profile',
    components: {
      loading,
      UserInformationForm,
      LoginCredentialsForm,
      SecurityQuestionForm,
      TermsOfUse,
      AlreadyRegisteredModal
    },
    data () {
      return {
        isModalOpen: false,
        showSpinner: false,
        reEnableSubmitButton: false,
        memberValidationData: {
          memberIdentifier: '',
          birthDate: ''
        },
        memberData: {
          firstName: '',
          lastName: '',
          phone: '',
          address: {
            city: '',
            state: '',
            street: '',
            street2: '',
            zipCode: ''
          }
        },
        userCredentials: {
          username: '',
          email: '',
          password: ''
        },
        securityQuestionCatalog: [],
        selectedSecurityQuestion: {
          id: '',
          question: '',
          answer: ''
        },
        termsOfUse: {
          subscribeToFitperks: true,
          acceptTerms: false
        }
      }
    },
    mounted () {
      // Validate UserInformation form upon entering
      setTimeout(() => {
        this.validateUserInformationOnLoad()
      }, 500)

      // Redirect user to memberValidation if status is set to false
      if (!this.getIsMemberValidated) {
        this.$router.push({path: '/'})
      }

      this.showSpinner = true
      this.showSpinner = false
      this.memberData = this.getMemberData
      this.userCredentials.email = this.getEmailAddress
      this.memberData.address.zipCode = this.memberData.address.zipCode.substr(0, 5)
      this.securityQuestionCatalog = this.getSecurityQuestionCatalog
    },
    methods: {
      setMemberData (data) {
        this.memberData = data
        this.memberData.firstName = StringUtils.initCaps(this.memberData.firstName)
        this.memberData.lastName = StringUtils.initCaps(this.memberData.lastName)
        this.memberData.address.city = StringUtils.initCaps(this.memberData.address.city)
        this.memberData.address.street = StringUtils.initCaps(this.memberData.address.street)
        this.memberData.address.street2 = StringUtils.initCaps(this.memberData.address.street2)
      },
      setUserCredentials (data) {
        this.userCredentials = data
      },
      setSelectedQuestion (data) {
        this.selectedSecurityQuestion = data
      },
      setTermsOfUseData (data) {
        this.termsOfUse = data
      },

      // Validate fields when entering page
      validateUserInformationOnLoad () {
        this.$validator.validate('userInformation.address-street')
        this.$validator.validate('userInformation.address-city')
        this.$validator.validate('userInformation.address-state')
        this.$validator.validate('userInformation.address-zip')
        this.$validator.validate('userInformation.phone')
        if (this.userCredentials.email.length > 0) {
          this.$validator.validate('loginCredentialsValidation.email')
        }
      },

      submitForm () {
        this.reEnableSubmitButton = false
        createProfileService.registerMember(this.userDataObject)
        .then((success) => {
          if (success.data.securityToken) {
            this.logUser(success.data.securityToken)
            if (this.termsOfUse.subscribeToFitperks && success.data.ctRegistration === 'false') {
              this.openModal()
            } else {
              this.goToMyProfile()
            }
          }
        }).catch((error) => {
          this.reEnableSubmitButton = true
          if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
            this.$toasted.show('<p>' + error.response.data.errorMessage + '</p>', {
              theme: 'primary',
              position: 'bottom-center',
              duration: 10000
            })
          } else {
            this.$toasted.show('There was an unexpected error when trying to register', {
              theme: 'primary',
              position: 'bottom-center',
              duration: 5000
            })
          }
        })
      },

      logUser (securityToken) {
        let Cookies = require('js-cookie')
        Cookies.set('securityToken', securityToken)
      },

      goToMyProfile () {
        window.open(createProfileService.getMyProfileUrl(), '_self')
      },

      openModal () {
        this.isModalOpen = true
      },

      closeModal () {
        this.isModalOpen = false
        this.goToMyProfile()
      },

      cancelRegistration () {
        if (confirm('This action will cancel your My24 Account Registration.  Are you sure you want to continue?')) {
          // Clearing store data
          this.$store.commit('setMemberValidationData', {})
          this.$store.commit('setMemberData', {})
          this.$store.commit('setSecurityQuestionCatalog', {})
          this.$store.commit('setMemberValidationStatus', false)

          this.$router.push({path: '/'})
        }
      }

    },
    computed: {
      // Vuex helper to map computed properties for the desired stored getters
      ...mapGetters([
        'getIsMemberValidated',
        'getMemberValidationData',
        'getMemberData',
        'getSecurityQuestionCatalog',
        'getEmailAddress'
      ]),

      areAllFormsValid () {
        // Check validity of User Information component
        if (this.fields.$userInformation || this.fields.$securityQuestionValidation || this.fields.$loginCredentialsValidation) {
          return Object.keys(this.fields.$userInformation).every(key => this.fields.$userInformation[key].valid) &&
                 Object.keys(this.fields.$securityQuestionValidation).every(key => this.fields.$securityQuestionValidation[key].valid) &&
                 Object.keys(this.fields.$loginCredentialsValidation).every(key => this.fields.$loginCredentialsValidation[key].valid)
        } else {
          return false
        }
      },

      userDataObject () {
        return {
          memberNumber: this.getMemberData.memberNumber,
          dateOfBirth: this.getMemberValidationData.birthDate,
          city: this.memberData.address.city,
          street: this.memberData.address.street,
          street2: this.memberData.address.street2,
          state: this.memberData.address.state,
          zipcode: this.memberData.address.zipCode,
          phoneNumber: this.memberData.phone,
          username: this.userCredentials.username,
          email: this.userCredentials.email,
          password: this.userCredentials.password,
          securityAnswer: this.selectedSecurityQuestion.answer,
          securityQuestion: this.selectedSecurityQuestion.question,
          securityQuestionId: this.selectedSecurityQuestion.id,
          fitPerksAgreements: this.termsOfUse.subscribeToFitperks.toString()
        }
      }

    }
  }
</script>

<style lang="scss">
  @import '~my-account-common-css/stylesheets/materialized.scss';
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss';
  @import '~my-account-common-css/stylesheets/container.scss';

  #create-profile-container {

    .profile-container {

      &#terms-of-use {

        width: 100%;
        margin: 0;
        padding: 0;

      }

      > .title-24 {

        margin: 0 auto 20px auto;

      }

    }

  }

</style>



// WEBPACK FOOTER //
// src/views/CreateProfile.vue